export const FORM_MODE = {
    READ: 1,
    CREATE: 2,
    UPDATE: 3,
}